export default __webpack_public_path__ + "static/media/appGallery-en.029a35b4.svg";